import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from '@app/core/services';
import { environment } from '@app/environment';
import { BASE_PATH } from "../../shared/rest-api";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private restAPI = inject(BASE_PATH);

  constructor(private configService: ConfigService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const config = this.configService.getConfig();
    if (req.url.includes(this.restAPI)) {
      const headerName = config()?.UmbracoBasicAuthHttpHeaderName || 'X-Authentication-Shared-Secret';
      const token = config()?.UmbracoBasicAuthHttpHeaderValue || environment.viceNewRestAPISecret;
      if (token) {
        const cloned = req.clone({
          headers: req.headers.set(headerName, token).set(config().UmbracoBasicAuthHttpHeaderName, config().UmbracoBasicAuthHttpHeaderValue)
        });
        return next.handle(cloned);
      }
    }
    return next.handle(req);
  }
}
